/**
 * en-GB messages added by shared reception task W-SR1 (docs/SHARED-RECEPTION-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts. UK English only.
 */
export const wSr1EnGB = {
    'srp.nav.buildings': 'Shared receptions',
    'srp.nav.buildings.desc': 'Buildings where one kiosk is shared by several organisations.',
    'srp.list.table': 'Shared receptions',
    'srp.list.searchHint': 'Search by name, address or operator',
    'srp.list.new': 'New shared reception',
    'srp.list.empty': 'No shared receptions yet. Create one to start inviting organisations.',
    'srp.col.name': 'Name',
    'srp.col.address': 'Address',
    'srp.col.operator': 'Operator',
    'srp.col.companies': 'Companies',
    'srp.col.devices': 'Tablets',
    'srp.col.status': 'Status',
    'srp.col.created': 'Created',
    'srp.col.actions': 'Actions',
    'srp.open': 'Open',
    'srp.openNamed': 'Open {name}',
    'srp.status.active': 'Active',
    'srp.status.archived': 'Archived',
    'srp.create.title': 'New shared reception',
    'srp.create.description': 'A building with one kiosk that several organisations share. You invite the organisations afterwards.',
    'srp.create.submit': 'Create shared reception',
    'srp.create.done': 'Shared reception created.',
    'srp.field.name': 'Building name',
    'srp.field.address': 'Address',
    'srp.field.timeZone': 'Time zone',
    'srp.field.timeZoneHint': 'Every organisation joining must use a site in this time zone.',
    'srp.field.operatorName': 'Operator name',
    'srp.field.operatorNameHint': 'Who runs the building. Shown on the invitation.',
    'srp.field.operatorEmail': 'Operator contact email',
    'srp.field.alertEmail': 'Fault alert email',
    'srp.field.alertEmailHint': 'Where tablet faults are emailed. Leave empty for none.',
    'srp.back': 'Back to shared receptions',
    'srp.detail.tabs': 'Shared reception sections',
    'srp.tab.details': 'Details',
    'srp.tab.invitations': 'Invitations',
    'srp.tab.order': 'Kiosk order',
    'srp.tab.staff': 'Building staff',
    'srp.tab.devices': 'Tablets',
    'srp.tab.phones': 'Marshal phones',
    'srp.tab.evacuations': 'Evacuations',
    'srp.tab.details.desc': 'The building, who runs it and where fault alerts go.',
    'srp.tab.invitations.desc': 'Invite an existing customer to share this reception and follow their answer.',
    'srp.tab.order.desc': 'The order companies appear in on the kiosk.',
    'srp.tab.staff.desc': 'People who manage the building and fire marshals who can use the building area.',
    'srp.tab.devices.desc': 'Shared tablets paired to this building.',
    'srp.tab.phones.desc': 'Phones enrolled by building marshals for the offline fire list.',
    'srp.tab.evacuations.desc': 'Past and current building evacuations. Counts only: names are never shown here.',
    'srp.details.save': 'Save changes',
    'srp.details.saved': 'Saved.',
    'srp.details.pin': 'Evacuation PIN',
    'srp.details.pinSet': 'A PIN is set. The building administrator can change it.',
    'srp.details.pinNotSet': 'No PIN set yet. The building administrator sets it in the building area.',
    'srp.details.archive': 'Archive shared reception',
    'srp.details.archiveHint': 'Unpairs every tablet and starts every company leaving. This cannot be undone.',
    'srp.details.archived': 'This shared reception is archived.',
    'srp.details.archiveDone': 'Shared reception archived.',
    'srp.inv.invite': 'Invite an organisation',
    'srp.inv.search': 'Find a customer',
    'srp.inv.searchHint': 'Search by customer name. The customer needs the Shared reception module switched on.',
    'srp.inv.customer': 'Customer',
    'srp.inv.choose': 'Choose a customer',
    'srp.inv.send': 'Send invitation',
    'srp.inv.sent': 'Invitation sent.',
    'srp.inv.table': 'Invitations and companies',
    'srp.inv.empty': 'No organisations invited yet.',
    'srp.inv.col.customer': 'Customer',
    'srp.inv.col.site': 'Site',
    'srp.inv.col.invited': 'Invited',
    'srp.inv.col.answered': 'Accepted',
    'srp.inv.withdraw': 'Withdraw',
    'srp.inv.withdrawNamed': 'Withdraw the invitation to {name}',
    'srp.inv.withdrawn': 'Invitation withdrawn.',
    'srp.inv.leavingUntil': 'Leaving until {date}',
    'srp.order.hint': 'Drag a company or use the arrows. Only companies that have accepted are listed.',
    'srp.order.list': 'Company order on the kiosk',
    'srp.order.empty': 'No company has accepted yet.',
    'srp.order.save': 'Save order',
    'srp.order.saved': 'Order saved.',
    'srp.staff.add': 'Add a staff member',
    'srp.staff.email': 'Email address',
    'srp.staff.fullName': 'Full name',
    'srp.staff.role': 'Role',
    'srp.staff.addSubmit': 'Add staff member',
    'srp.staff.added': 'Staff member added. They have been emailed an invitation.',
    'srp.staff.table': 'Building staff',
    'srp.staff.empty': 'No building staff yet.',
    'srp.staff.col.phones': 'Phones',
    'srp.staff.col.added': 'Added',
    'srp.staff.remove': 'Remove',
    'srp.staff.removeNamed': 'Remove {name}',
    'srp.staff.removed': 'Staff member removed.',
    'srp.dev.pairing': 'Pair a tablet',
    'srp.dev.pairingName': 'Tablet name',
    'srp.dev.pairingNameHint': 'For example Main reception.',
    'srp.dev.pairingCreate': 'Create pairing code',
    'srp.dev.pairingCode': 'Pairing code',
    'srp.dev.pairingShown': 'Enter this code on the tablet. It is shown once and expires at {time}.',
    'srp.dev.table': 'Shared tablets',
    'srp.dev.empty': 'No tablets paired yet.',
    'srp.dev.col.name': 'Tablet',
    'srp.dev.col.status': 'Status',
    'srp.dev.col.seen': 'Last seen',
    'srp.dev.col.version': 'App version',
    'srp.dev.col.battery': 'Battery',
    'srp.dev.col.links': 'Companies linked',
    'srp.dev.online': 'Online',
    'srp.dev.offline': 'Offline',
    'srp.dev.revoked': 'Unpaired',
    'srp.dev.unpair': 'Unpair',
    'srp.dev.unpairNamed': 'Unpair {name}',
    'srp.dev.unpaired': 'Tablet unpaired.',
    'srp.dev.noLinks': 'None',
    'srp.dev.charging': 'charging',
    'srp.phones.table': 'Marshal phones',
    'srp.phones.empty': 'No marshal phones enrolled.',
    'srp.phones.col.person': 'Person',
    'srp.phones.col.phone': 'Phone',
    'srp.phones.col.enrolled': 'Enrolled',
    'srp.phones.col.seen': 'Last seen',
    'srp.phones.col.expires': 'Expires',
    'srp.phones.remove': 'Remove',
    'srp.phones.removeNamed': 'Remove the phone of {name}',
    'srp.phones.removed': 'Phone removed.',
    'srp.phones.removedBadge': 'Removed',
    'srp.evac.table': 'Building evacuations',
    'srp.evac.empty': 'No building evacuations yet.',
    'srp.evac.col.started': 'Started',
    'srp.evac.col.kind': 'Type',
    'srp.evac.col.status': 'Status',
    'srp.evac.col.by': 'Started by',
    'srp.evac.col.ended': 'Ended',
    'srp.evac.col.companies': 'Companies',
    'srp.evac.col.counts': 'Counts',
    'srp.evac.kind.real': 'Real evacuation',
    'srp.evac.kind.drill': 'Drill',
    'srp.evac.status.active': 'Active',
    'srp.evac.status.ended': 'Ended',
    'srp.evac.source.kiosk': 'The kiosk',
    'srp.evac.source.building': 'Building area',
    'srp.evac.source.member': 'A company',
    'srp.evac.source.phone': 'A marshal phone',
    'srp.evac.source.system': 'The system',
    'srp.evac.counts': '{unaccounted} unaccounted, {safe} safe, {missing} missing, {offSite} off site',
    'srp.evac.namesDeleted': 'Names deleted',
    'srp.evac.namesKept': 'Names kept',
};
//# sourceMappingURL=w-sr1.js.map